import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SlotReduxCommandCreator } from 'appRedux/actions/slotCommandCreator';
import { SlotCompareReduxCommandCreator } from 'appRedux/actions/slotCompareCommandCreator';
import { displayFilterChipLabel } from 'common/filterChipLabel';
import React from 'react';
import { useDispatch } from 'react-redux';

interface ITagProps {
  text: string;
  bankFilter: boolean;
  onRemove: () => void;
}

const RemovableTag: React.FC<ITagProps> = ({ text, bankFilter, onRemove }) => {
  const dispatch = useDispatch();
  const slotCommands = SlotReduxCommandCreator(dispatch);
  const slotCompareCommands = SlotCompareReduxCommandCreator(dispatch);

  const handleClearSearch = () => {
    if (onRemove) {
      onRemove();
    }
    slotCommands.ClearSelectedSlots();
    slotCommands.SelectBankFilter(false);
    slotCompareCommands.clearSlots();
  };

  return (
    <span className="shortcut-pill shortcut-pill--active">
      {displayFilterChipLabel(text, bankFilter)}
      <FontAwesomeIcon icon={faClose} onClick={handleClearSearch} />
    </span>
  );
};

export default RemovableTag;
